//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBase {
  protected transformOptions(options: any): Promise<any> {
    const token = localStorage.getItem('token'); // if using JWT
    if (token) options.headers['Authorization'] = `Bearer ${token}`;

    const viewAsWorkspace = localStorage.getItem('viewAsWorkspaceId');
    if (viewAsWorkspace) options.headers['X-View-As-Workspace'] = viewAsWorkspace;

    return Promise.resolve(options);
  }

  /**
   * Extracts and cleans error messages from ApiException.
   * Handles JSON-stringified responses from the backend (removes quotes).
   */
  static getCleanErrorMessage(error: any, fallback: string = 'An error occurred'): string {
    let msg = error?.response || error?.message || fallback;
    try {
      msg = JSON.parse(msg);
    } catch {
      // If not JSON, use as-is
    }
    return msg;
  }
}

export interface IAssignmentDefinitionsClient {

    createDefinition(request: AssignmentDefinition): Promise<AssignmentDefinition>;

    getAllDefinitions(workspaceId?: number | null | undefined, courseId?: number | null | undefined): Promise<AssignmentDefinition[]>;

    getCourseDefinitions(courseId: number): Promise<AssignmentDefinition[]>;

    getDefinitionById(id: number): Promise<AssignmentDefinition>;

    updateDefinition(id: number, request: UpdateAssignmentDefinitionRequest): Promise<AssignmentDefinition>;

    deleteDefinition(id: number): Promise<boolean>;

    archiveDefinition(id: number): Promise<boolean>;

    cloneDefinition(id: number, request: CloneAssignmentDefinitionRequest): Promise<AssignmentDefinition>;
}

export class AssignmentDefinitionsClient extends ApiBase implements IAssignmentDefinitionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    createDefinition(request: AssignmentDefinition): Promise<AssignmentDefinition> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDefinition(_response);
        });
    }

    protected processCreateDefinition(response: Response): Promise<AssignmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition>(null as any);
    }

    getAllDefinitions(workspaceId?: number | null | undefined, courseId?: number | null | undefined): Promise<AssignmentDefinition[]> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDefinitions(_response);
        });
    }

    protected processGetAllDefinitions(response: Response): Promise<AssignmentDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition[]>(null as any);
    }

    getCourseDefinitions(courseId: number): Promise<AssignmentDefinition[]> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/course/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseDefinitions(_response);
        });
    }

    protected processGetCourseDefinitions(response: Response): Promise<AssignmentDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition[]>(null as any);
    }

    getDefinitionById(id: number): Promise<AssignmentDefinition> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefinitionById(_response);
        });
    }

    protected processGetDefinitionById(response: Response): Promise<AssignmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition>(null as any);
    }

    updateDefinition(id: number, request: UpdateAssignmentDefinitionRequest): Promise<AssignmentDefinition> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDefinition(_response);
        });
    }

    protected processUpdateDefinition(response: Response): Promise<AssignmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition>(null as any);
    }

    deleteDefinition(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDefinition(_response);
        });
    }

    protected processDeleteDefinition(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    archiveDefinition(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveDefinition(_response);
        });
    }

    protected processArchiveDefinition(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    cloneDefinition(id: number, request: CloneAssignmentDefinitionRequest): Promise<AssignmentDefinition> {
        let url_ = this.baseUrl + "/api/AssignmentDefinitions/{id}/clone";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCloneDefinition(_response);
        });
    }

    protected processCloneDefinition(response: Response): Promise<AssignmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentDefinition;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentDefinition>(null as any);
    }
}

export interface IAuthClient {

    createUser(signupRequest: SignupRequest): Promise<SignupResponse>;

    login(loginRequest: LoginRequest): Promise<LoginResponse>;

    checkSession(): Promise<CheckSessionResponse>;

    getAccountByDomain(): Promise<Account>;

    sendVerifyCode(sendCodeRequest: SendCodeRequest): Promise<MessageResponse>;

    validateVerifyCode(verifyCodeRequest: VerifyCodeRequest): Promise<MessageResponse>;

    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest): Promise<MessageResponse>;

    me(): Promise<UserInfoDto>;

    updateProfile(request: UpdateProfileRequest): Promise<UpdateProfileResponse>;

    acceptInvite(request: AcceptInvitationRequest): Promise<AcceptInviteResponse>;

    changePassword(request: ChangePasswordRequest): Promise<MessageResponse>;

    impersonate(userId: number): Promise<ImpersonateResponse>;
}

export class AuthClient extends ApiBase implements IAuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    createUser(signupRequest: SignupRequest): Promise<SignupResponse> {
        let url_ = this.baseUrl + "/api/Auth/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signupRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<SignupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SignupResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignupResponse>(null as any);
    }

    login(loginRequest: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    checkSession(): Promise<CheckSessionResponse> {
        let url_ = this.baseUrl + "/api/Auth/check-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckSession(_response);
        });
    }

    protected processCheckSession(response: Response): Promise<CheckSessionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckSessionResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckSessionResponse>(null as any);
    }

    getAccountByDomain(): Promise<Account> {
        let url_ = this.baseUrl + "/api/Auth/account-by-domain";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountByDomain(_response);
        });
    }

    protected processGetAccountByDomain(response: Response): Promise<Account> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Account>(null as any);
    }

    sendVerifyCode(sendCodeRequest: SendCodeRequest): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/api/Auth/send-verify-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendCodeRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendVerifyCode(_response);
        });
    }

    protected processSendVerifyCode(response: Response): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    validateVerifyCode(verifyCodeRequest: VerifyCodeRequest): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/api/Auth/validate-verify-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verifyCodeRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateVerifyCode(_response);
        });
    }

    protected processValidateVerifyCode(response: Response): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/api/Auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    me(): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoDto;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    updateProfile(request: UpdateProfileRequest): Promise<UpdateProfileResponse> {
        let url_ = this.baseUrl + "/api/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<UpdateProfileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateProfileResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateProfileResponse>(null as any);
    }

    acceptInvite(request: AcceptInvitationRequest): Promise<AcceptInviteResponse> {
        let url_ = this.baseUrl + "/api/Auth/accept-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptInvite(_response);
        });
    }

    protected processAcceptInvite(response: Response): Promise<AcceptInviteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptInviteResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptInviteResponse>(null as any);
    }

    changePassword(request: ChangePasswordRequest): Promise<MessageResponse> {
        let url_ = this.baseUrl + "/api/Auth/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<MessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResponse>(null as any);
    }

    impersonate(userId: number): Promise<ImpersonateResponse> {
        let url_ = this.baseUrl + "/api/Auth/impersonate/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonate(_response);
        });
    }

    protected processImpersonate(response: Response): Promise<ImpersonateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpersonateResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpersonateResponse>(null as any);
    }
}

export interface ICertificatesClient {

    getMyCertificates(): Promise<Certificate[]>;

    getCertificateById(id: number): Promise<Certificate>;

    getCertificateByEnrollment(enrollmentId: number): Promise<Certificate>;

    getCertificateDownloadUrl(id: number): Promise<string>;

    emailCertificate(id: number, request: EmailCertificateRequest): Promise<FileResponse>;

    generateCertificate(enrollmentId: number): Promise<Certificate>;

    getAccountCertificates(courseId?: number | null | undefined, userId?: number | null | undefined): Promise<Certificate[]>;
}

export class CertificatesClient extends ApiBase implements ICertificatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getMyCertificates(): Promise<Certificate[]> {
        let url_ = this.baseUrl + "/api/Certificates/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyCertificates(_response);
        });
    }

    protected processGetMyCertificates(response: Response): Promise<Certificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Certificate[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate[]>(null as any);
    }

    getCertificateById(id: number): Promise<Certificate> {
        let url_ = this.baseUrl + "/api/Certificates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCertificateById(_response);
        });
    }

    protected processGetCertificateById(response: Response): Promise<Certificate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Certificate;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate>(null as any);
    }

    getCertificateByEnrollment(enrollmentId: number): Promise<Certificate> {
        let url_ = this.baseUrl + "/api/Certificates/enrollment/{enrollmentId}";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCertificateByEnrollment(_response);
        });
    }

    protected processGetCertificateByEnrollment(response: Response): Promise<Certificate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Certificate;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate>(null as any);
    }

    getCertificateDownloadUrl(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Certificates/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCertificateDownloadUrl(_response);
        });
    }

    protected processGetCertificateDownloadUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    emailCertificate(id: number, request: EmailCertificateRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Certificates/{id}/email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailCertificate(_response);
        });
    }

    protected processEmailCertificate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateCertificate(enrollmentId: number): Promise<Certificate> {
        let url_ = this.baseUrl + "/api/Certificates/generate/{enrollmentId}";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateCertificate(_response);
        });
    }

    protected processGenerateCertificate(response: Response): Promise<Certificate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Certificate;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate>(null as any);
    }

    getAccountCertificates(courseId?: number | null | undefined, userId?: number | null | undefined): Promise<Certificate[]> {
        let url_ = this.baseUrl + "/api/Certificates/account?";
        if (courseId !== undefined && courseId !== null)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountCertificates(_response);
        });
    }

    protected processGetAccountCertificates(response: Response): Promise<Certificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Certificate[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate[]>(null as any);
    }
}

export interface ICertificateTemplatesClient {

    getActiveTemplate(): Promise<CertificateTemplate>;

    saveTemplate(request: SaveCertificateTemplateRequest): Promise<CertificateTemplate>;
}

export class CertificateTemplatesClient extends ApiBase implements ICertificateTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getActiveTemplate(): Promise<CertificateTemplate> {
        let url_ = this.baseUrl + "/api/certificate-templates/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveTemplate(_response);
        });
    }

    protected processGetActiveTemplate(response: Response): Promise<CertificateTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTemplate;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTemplate>(null as any);
    }

    saveTemplate(request: SaveCertificateTemplateRequest): Promise<CertificateTemplate> {
        let url_ = this.baseUrl + "/api/certificate-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTemplate(_response);
        });
    }

    protected processSaveTemplate(response: Response): Promise<CertificateTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTemplate;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTemplate>(null as any);
    }
}

export interface ICourseAuthorsClient {

    list(): Promise<CourseAuthor[]>;

    create(request: SaveCourseAuthorRequest): Promise<CourseAuthor>;

    update(id: number, request: SaveCourseAuthorRequest): Promise<CourseAuthor>;

    delete(id: number): Promise<boolean>;
}

export class CourseAuthorsClient extends ApiBase implements ICourseAuthorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    list(): Promise<CourseAuthor[]> {
        let url_ = this.baseUrl + "/api/CourseAuthors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<CourseAuthor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseAuthor[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseAuthor[]>(null as any);
    }

    create(request: SaveCourseAuthorRequest): Promise<CourseAuthor> {
        let url_ = this.baseUrl + "/api/CourseAuthors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CourseAuthor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseAuthor;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseAuthor>(null as any);
    }

    update(id: number, request: SaveCourseAuthorRequest): Promise<CourseAuthor> {
        let url_ = this.baseUrl + "/api/CourseAuthors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CourseAuthor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseAuthor;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseAuthor>(null as any);
    }

    delete(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CourseAuthors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ICourseCustomFieldsClient {

    list(): Promise<CourseCustomField[]>;

    create(request: SaveCourseCustomFieldRequest): Promise<CourseCustomField>;

    update(id: number, request: SaveCourseCustomFieldRequest): Promise<CourseCustomField>;

    delete(id: number): Promise<boolean>;

    getValues(courseId: number): Promise<CourseCustomFieldValue[]>;

    setValue(courseId: number, request: SetCourseCustomFieldValueRequest): Promise<FileResponse>;
}

export class CourseCustomFieldsClient extends ApiBase implements ICourseCustomFieldsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    list(): Promise<CourseCustomField[]> {
        let url_ = this.baseUrl + "/api/CourseCustomFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<CourseCustomField[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseCustomField[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseCustomField[]>(null as any);
    }

    create(request: SaveCourseCustomFieldRequest): Promise<CourseCustomField> {
        let url_ = this.baseUrl + "/api/CourseCustomFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CourseCustomField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseCustomField;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseCustomField>(null as any);
    }

    update(id: number, request: SaveCourseCustomFieldRequest): Promise<CourseCustomField> {
        let url_ = this.baseUrl + "/api/CourseCustomFields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CourseCustomField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseCustomField;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseCustomField>(null as any);
    }

    delete(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CourseCustomFields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getValues(courseId: number): Promise<CourseCustomFieldValue[]> {
        let url_ = this.baseUrl + "/api/CourseCustomFields/values/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetValues(_response);
        });
    }

    protected processGetValues(response: Response): Promise<CourseCustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseCustomFieldValue[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseCustomFieldValue[]>(null as any);
    }

    setValue(courseId: number, request: SetCourseCustomFieldValueRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseCustomFields/values/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetValue(_response);
        });
    }

    protected processSetValue(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICourseDetailTabsClient {

    list(courseId: number): Promise<CourseDetailTab[]>;
}

export class CourseDetailTabsClient extends ApiBase implements ICourseDetailTabsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    list(courseId: number): Promise<CourseDetailTab[]> {
        let url_ = this.baseUrl + "/api/courses/{courseId}/detail-tabs";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<CourseDetailTab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseDetailTab[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseDetailTab[]>(null as any);
    }
}

export interface ICourseEnrollmentsClient {

    searchUserEnrollments(userId: number, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;

    searchCourseEnrollments(courseId: number, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;

    getEnrollmentById(enrollmentId: number): Promise<CourseEnrollment>;

    createEnrollment(request: CreateEnrollmentRequest): Promise<CourseEnrollment>;

    startCourse(request: StartCourseRequest): Promise<CourseEnrollment>;

    updateLastAccessed(enrollmentId: number): Promise<boolean>;

    completeExternalCourse(request: CompleteExternalCourseRequest): Promise<CourseEnrollment>;

    adminCompleteCourse(request: AdminCompleteCourseRequest): Promise<CourseEnrollment>;

    revokeEnrollment(enrollmentId: number): Promise<CourseEnrollment>;

    unrevokeEnrollment(enrollmentId: number): Promise<CourseEnrollment>;
}

export class CourseEnrollmentsClient extends ApiBase implements ICourseEnrollmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchUserEnrollments(userId: number, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/user/{userId}/search?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUserEnrollments(_response);
        });
    }

    protected processSearchUserEnrollments(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }

    searchCourseEnrollments(courseId: number, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/course/{courseId}/search?";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseEnrollments(_response);
        });
    }

    protected processSearchCourseEnrollments(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }

    getEnrollmentById(enrollmentId: number): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/{enrollmentId}";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnrollmentById(_response);
        });
    }

    protected processGetEnrollmentById(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    createEnrollment(request: CreateEnrollmentRequest): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEnrollment(_response);
        });
    }

    protected processCreateEnrollment(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    startCourse(request: StartCourseRequest): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartCourse(_response);
        });
    }

    protected processStartCourse(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    updateLastAccessed(enrollmentId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/{enrollmentId}/last-accessed";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLastAccessed(_response);
        });
    }

    protected processUpdateLastAccessed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    completeExternalCourse(request: CompleteExternalCourseRequest): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/external-complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteExternalCourse(_response);
        });
    }

    protected processCompleteExternalCourse(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    adminCompleteCourse(request: AdminCompleteCourseRequest): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/admin-complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminCompleteCourse(_response);
        });
    }

    protected processAdminCompleteCourse(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    revokeEnrollment(enrollmentId: number): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/{enrollmentId}/revoke";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRevokeEnrollment(_response);
        });
    }

    protected processRevokeEnrollment(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }

    unrevokeEnrollment(enrollmentId: number): Promise<CourseEnrollment> {
        let url_ = this.baseUrl + "/api/CourseEnrollments/{enrollmentId}/unrevoke";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnrevokeEnrollment(_response);
        });
    }

    protected processUnrevokeEnrollment(response: Response): Promise<CourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseEnrollment>(null as any);
    }
}

export interface ICoursesClient {

    addCourse(courseRequest: AddCourseRequest): Promise<Course>;

    getCourses(id?: number | null | undefined, name?: string | null | undefined, accountId?: number | null | undefined, workspaceId?: number | null | undefined, isDraft?: boolean | null | undefined, tagIds?: number[] | null | undefined, publishedDateFrom?: Date | null | undefined, publishedDateTo?: Date | null | undefined, myCourses?: boolean | null | undefined, isAssigned?: boolean | null | undefined, courseType?: CourseType | null | undefined, offset?: number | undefined, limit?: number | undefined, securityWorkspaceId?: number | null | undefined, isPublicOnly?: boolean | null | undefined): Promise<Course[]>;

    getCoursesCount(id?: number | null | undefined, name?: string | null | undefined, accountId?: number | null | undefined, workspaceId?: number | null | undefined, isDraft?: boolean | null | undefined, tagIds?: number[] | null | undefined, publishedDateFrom?: Date | null | undefined, publishedDateTo?: Date | null | undefined, myCourses?: boolean | null | undefined, isAssigned?: boolean | null | undefined, courseType?: CourseType | null | undefined, offset?: number | undefined, limit?: number | undefined, securityWorkspaceId?: number | null | undefined, isPublicOnly?: boolean | null | undefined): Promise<number>;

    getCourseBySlug(slug: string): Promise<Course>;

    getCourseById(id: number): Promise<Course>;

    updateCourse(id: number, updateRequest: AddCourseRequest): Promise<Course>;

    deleteCourse(id: number): Promise<boolean>;

    startDetailVideoUpload(id: number): Promise<VideoAssetUploadTicket>;

    clearDetailVideo(id: number): Promise<FileResponse>;

    addCourseToPath(id: number, request: AddPathCourseRequest): Promise<LearningPathCourse>;

    removeCourseFromPath(id: number, courseId: number): Promise<FileResponse>;

    reorderPathCourses(id: number, request: ReorderPathCoursesRequest): Promise<FileResponse>;
}

export class CoursesClient extends ApiBase implements ICoursesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    addCourse(courseRequest: AddCourseRequest): Promise<Course> {
        let url_ = this.baseUrl + "/api/Courses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCourse(_response);
        });
    }

    protected processAddCourse(response: Response): Promise<Course> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Course;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Course>(null as any);
    }

    getCourses(id?: number | null | undefined, name?: string | null | undefined, accountId?: number | null | undefined, workspaceId?: number | null | undefined, isDraft?: boolean | null | undefined, tagIds?: number[] | null | undefined, publishedDateFrom?: Date | null | undefined, publishedDateTo?: Date | null | undefined, myCourses?: boolean | null | undefined, isAssigned?: boolean | null | undefined, courseType?: CourseType | null | undefined, offset?: number | undefined, limit?: number | undefined, securityWorkspaceId?: number | null | undefined, isPublicOnly?: boolean | null | undefined): Promise<Course[]> {
        let url_ = this.baseUrl + "/api/Courses?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (isDraft !== undefined && isDraft !== null)
            url_ += "IsDraft=" + encodeURIComponent("" + isDraft) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (publishedDateFrom !== undefined && publishedDateFrom !== null)
            url_ += "PublishedDateFrom=" + encodeURIComponent(publishedDateFrom ? "" + publishedDateFrom.toISOString() : "") + "&";
        if (publishedDateTo !== undefined && publishedDateTo !== null)
            url_ += "PublishedDateTo=" + encodeURIComponent(publishedDateTo ? "" + publishedDateTo.toISOString() : "") + "&";
        if (myCourses !== undefined && myCourses !== null)
            url_ += "MyCourses=" + encodeURIComponent("" + myCourses) + "&";
        if (isAssigned !== undefined && isAssigned !== null)
            url_ += "IsAssigned=" + encodeURIComponent("" + isAssigned) + "&";
        if (courseType !== undefined && courseType !== null)
            url_ += "CourseType=" + encodeURIComponent("" + courseType) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (securityWorkspaceId !== undefined && securityWorkspaceId !== null)
            url_ += "SecurityWorkspaceId=" + encodeURIComponent("" + securityWorkspaceId) + "&";
        if (isPublicOnly !== undefined && isPublicOnly !== null)
            url_ += "IsPublicOnly=" + encodeURIComponent("" + isPublicOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: Response): Promise<Course[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Course[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Course[]>(null as any);
    }

    getCoursesCount(id?: number | null | undefined, name?: string | null | undefined, accountId?: number | null | undefined, workspaceId?: number | null | undefined, isDraft?: boolean | null | undefined, tagIds?: number[] | null | undefined, publishedDateFrom?: Date | null | undefined, publishedDateTo?: Date | null | undefined, myCourses?: boolean | null | undefined, isAssigned?: boolean | null | undefined, courseType?: CourseType | null | undefined, offset?: number | undefined, limit?: number | undefined, securityWorkspaceId?: number | null | undefined, isPublicOnly?: boolean | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Courses/count?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (isDraft !== undefined && isDraft !== null)
            url_ += "IsDraft=" + encodeURIComponent("" + isDraft) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (publishedDateFrom !== undefined && publishedDateFrom !== null)
            url_ += "PublishedDateFrom=" + encodeURIComponent(publishedDateFrom ? "" + publishedDateFrom.toISOString() : "") + "&";
        if (publishedDateTo !== undefined && publishedDateTo !== null)
            url_ += "PublishedDateTo=" + encodeURIComponent(publishedDateTo ? "" + publishedDateTo.toISOString() : "") + "&";
        if (myCourses !== undefined && myCourses !== null)
            url_ += "MyCourses=" + encodeURIComponent("" + myCourses) + "&";
        if (isAssigned !== undefined && isAssigned !== null)
            url_ += "IsAssigned=" + encodeURIComponent("" + isAssigned) + "&";
        if (courseType !== undefined && courseType !== null)
            url_ += "CourseType=" + encodeURIComponent("" + courseType) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (securityWorkspaceId !== undefined && securityWorkspaceId !== null)
            url_ += "SecurityWorkspaceId=" + encodeURIComponent("" + securityWorkspaceId) + "&";
        if (isPublicOnly !== undefined && isPublicOnly !== null)
            url_ += "IsPublicOnly=" + encodeURIComponent("" + isPublicOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCoursesCount(_response);
        });
    }

    protected processGetCoursesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getCourseBySlug(slug: string): Promise<Course> {
        let url_ = this.baseUrl + "/api/Courses/slug/{slug}";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseBySlug(_response);
        });
    }

    protected processGetCourseBySlug(response: Response): Promise<Course> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Course;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Course>(null as any);
    }

    getCourseById(id: number): Promise<Course> {
        let url_ = this.baseUrl + "/api/Courses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseById(_response);
        });
    }

    protected processGetCourseById(response: Response): Promise<Course> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Course;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Course>(null as any);
    }

    updateCourse(id: number, updateRequest: AddCourseRequest): Promise<Course> {
        let url_ = this.baseUrl + "/api/Courses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourse(_response);
        });
    }

    protected processUpdateCourse(response: Response): Promise<Course> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Course;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Course>(null as any);
    }

    deleteCourse(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Courses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourse(_response);
        });
    }

    protected processDeleteCourse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    startDetailVideoUpload(id: number): Promise<VideoAssetUploadTicket> {
        let url_ = this.baseUrl + "/api/Courses/{id}/detail-video-upload";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartDetailVideoUpload(_response);
        });
    }

    protected processStartDetailVideoUpload(response: Response): Promise<VideoAssetUploadTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VideoAssetUploadTicket;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoAssetUploadTicket>(null as any);
    }

    clearDetailVideo(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Courses/{id}/detail-video";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClearDetailVideo(_response);
        });
    }

    protected processClearDetailVideo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addCourseToPath(id: number, request: AddPathCourseRequest): Promise<LearningPathCourse> {
        let url_ = this.baseUrl + "/api/Courses/{id}/path-courses";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCourseToPath(_response);
        });
    }

    protected processAddCourseToPath(response: Response): Promise<LearningPathCourse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningPathCourse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningPathCourse>(null as any);
    }

    removeCourseFromPath(id: number, courseId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Courses/{id}/path-courses/{courseId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveCourseFromPath(_response);
        });
    }

    protected processRemoveCourseFromPath(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    reorderPathCourses(id: number, request: ReorderPathCoursesRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Courses/{id}/path-courses/reorder";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderPathCourses(_response);
        });
    }

    protected processReorderPathCourses(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGroupsClient {

    searchGroups(workspaceId?: number | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfGroup>;

    getAllGroupMemberships(workspaceId?: number | null | undefined): Promise<UserGroup[]>;

    getOwnedGroups(): Promise<Group[]>;

    getGroupById(id: number): Promise<Group>;

    updateGroup(id: number, request: SaveGroupRequest): Promise<Group>;

    deleteGroup(id: number): Promise<FileResponse>;

    createGroup(request: SaveGroupRequest): Promise<Group>;

    updateGroupAccess(id: number, request: UpdateGroupAccessRequest): Promise<Group>;

    getGroupMembers(id: number): Promise<UserGroup[]>;

    addUsersToGroup(id: number, request: ManageGroupMembersRequest): Promise<FileResponse>;

    removeUsersFromGroup(id: number, request: ManageGroupMembersRequest): Promise<FileResponse>;

    changeGroupOwner(id: number, request: ChangeGroupOwnerRequest): Promise<Group>;

    getUserGroups(userId: number): Promise<UserGroup[]>;
}

export class GroupsClient extends ApiBase implements IGroupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchGroups(workspaceId?: number | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfGroup> {
        let url_ = this.baseUrl + "/api/Groups/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchGroups(_response);
        });
    }

    protected processSearchGroups(response: Response): Promise<PagedResultOfGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfGroup;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfGroup>(null as any);
    }

    getAllGroupMemberships(workspaceId?: number | null | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/api/Groups/memberships?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGroupMemberships(_response);
        });
    }

    protected processGetAllGroupMemberships(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }

    getOwnedGroups(): Promise<Group[]> {
        let url_ = this.baseUrl + "/api/Groups/owned";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOwnedGroups(_response);
        });
    }

    protected processGetOwnedGroups(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(null as any);
    }

    getGroupById(id: number): Promise<Group> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupById(_response);
        });
    }

    protected processGetGroupById(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    updateGroup(id: number, request: SaveGroupRequest): Promise<Group> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroup(_response);
        });
    }

    protected processUpdateGroup(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    deleteGroup(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGroup(_response);
        });
    }

    protected processDeleteGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createGroup(request: SaveGroupRequest): Promise<Group> {
        let url_ = this.baseUrl + "/api/Groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    updateGroupAccess(id: number, request: UpdateGroupAccessRequest): Promise<Group> {
        let url_ = this.baseUrl + "/api/Groups/{id}/access";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroupAccess(_response);
        });
    }

    protected processUpdateGroupAccess(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    getGroupMembers(id: number): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/api/Groups/{id}/members";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupMembers(_response);
        });
    }

    protected processGetGroupMembers(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }

    addUsersToGroup(id: number, request: ManageGroupMembersRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Groups/{id}/members";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUsersToGroup(_response);
        });
    }

    protected processAddUsersToGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeUsersFromGroup(id: number, request: ManageGroupMembersRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Groups/{id}/members";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUsersFromGroup(_response);
        });
    }

    protected processRemoveUsersFromGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changeGroupOwner(id: number, request: ChangeGroupOwnerRequest): Promise<Group> {
        let url_ = this.baseUrl + "/api/Groups/{id}/owner";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeGroupOwner(_response);
        });
    }

    protected processChangeGroupOwner(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    getUserGroups(userId: number): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/api/Groups/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroups(_response);
        });
    }

    protected processGetUserGroups(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }
}

export interface ILearnerProfileClient {

    getProfession(userId: number): Promise<number | null>;

    setProfession(userId: number, request: SetProfessionRequest): Promise<FileResponse>;

    getLicenses(userId: number): Promise<LearnerLicense[]>;

    createLicense(userId: number, request: SaveLearnerLicenseRequest): Promise<LearnerLicense>;

    saveLicenses(userId: number, request: SaveLearnerLicensesRequest): Promise<LearnerLicense[]>;

    updateLicense(userId: number, id: number, request: SaveLearnerLicenseRequest): Promise<LearnerLicense>;

    deleteLicense(id: number): Promise<boolean>;
}

export class LearnerProfileClient extends ApiBase implements ILearnerProfileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getProfession(userId: number): Promise<number | null> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/profession";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfession(_response);
        });
    }

    protected processGetProfession(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    setProfession(userId: number, request: SetProfessionRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/profession";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetProfession(_response);
        });
    }

    protected processSetProfession(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLicenses(userId: number): Promise<LearnerLicense[]> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/licenses";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: Response): Promise<LearnerLicense[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearnerLicense[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearnerLicense[]>(null as any);
    }

    createLicense(userId: number, request: SaveLearnerLicenseRequest): Promise<LearnerLicense> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/licenses";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLicense(_response);
        });
    }

    protected processCreateLicense(response: Response): Promise<LearnerLicense> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearnerLicense;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearnerLicense>(null as any);
    }

    saveLicenses(userId: number, request: SaveLearnerLicensesRequest): Promise<LearnerLicense[]> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/licenses";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveLicenses(_response);
        });
    }

    protected processSaveLicenses(response: Response): Promise<LearnerLicense[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearnerLicense[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearnerLicense[]>(null as any);
    }

    updateLicense(userId: number, id: number, request: SaveLearnerLicenseRequest): Promise<LearnerLicense> {
        let url_ = this.baseUrl + "/api/learner-profile/{userId}/licenses/{id}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLicense(_response);
        });
    }

    protected processUpdateLicense(response: Response): Promise<LearnerLicense> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearnerLicense;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearnerLicense>(null as any);
    }

    deleteLicense(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/learner-profile/licenses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLicense(_response);
        });
    }

    protected processDeleteLicense(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ILessonCompletionsClient {

    getEnrollmentCompletions(enrollmentId: number): Promise<LessonCompletion[]>;

    markLessonComplete(request: MarkLessonCompleteRequest): Promise<LessonCompletion>;

    isLessonCompleted(enrollmentId: number, lessonId: number): Promise<boolean>;
}

export class LessonCompletionsClient extends ApiBase implements ILessonCompletionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getEnrollmentCompletions(enrollmentId: number): Promise<LessonCompletion[]> {
        let url_ = this.baseUrl + "/api/LessonCompletions/enrollment/{enrollmentId}";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnrollmentCompletions(_response);
        });
    }

    protected processGetEnrollmentCompletions(response: Response): Promise<LessonCompletion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LessonCompletion[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LessonCompletion[]>(null as any);
    }

    markLessonComplete(request: MarkLessonCompleteRequest): Promise<LessonCompletion> {
        let url_ = this.baseUrl + "/api/LessonCompletions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkLessonComplete(_response);
        });
    }

    protected processMarkLessonComplete(response: Response): Promise<LessonCompletion> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LessonCompletion;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LessonCompletion>(null as any);
    }

    isLessonCompleted(enrollmentId: number, lessonId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/LessonCompletions/enrollment/{enrollmentId}/lesson/{lessonId}/completed";
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        if (lessonId === undefined || lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' must be defined.");
        url_ = url_.replace("{lessonId}", encodeURIComponent("" + lessonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsLessonCompleted(_response);
        });
    }

    protected processIsLessonCompleted(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ILessonsClient {

    addLesson(lessonRequest: AddLessonRequest, courseId: number): Promise<Lesson>;

    getLessonsByCourse(courseId: number): Promise<Lesson[]>;

    getLessonById(id: number): Promise<Lesson>;

    updateLesson(id: number, updateRequest: AddLessonRequest): Promise<Lesson>;

    deleteLesson(id: number): Promise<boolean>;

    reorderLessons(courseId: number, lessonIds: number[]): Promise<boolean>;

    uploadScormPackage(id: number, file?: FileParameter | null | undefined): Promise<ScormUploadResult>;
}

export class LessonsClient extends ApiBase implements ILessonsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    addLesson(lessonRequest: AddLessonRequest, courseId: number): Promise<Lesson> {
        let url_ = this.baseUrl + "/api/Lessons/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lessonRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddLesson(_response);
        });
    }

    protected processAddLesson(response: Response): Promise<Lesson> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lesson;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lesson>(null as any);
    }

    getLessonsByCourse(courseId: number): Promise<Lesson[]> {
        let url_ = this.baseUrl + "/api/Lessons/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLessonsByCourse(_response);
        });
    }

    protected processGetLessonsByCourse(response: Response): Promise<Lesson[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lesson[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lesson[]>(null as any);
    }

    getLessonById(id: number): Promise<Lesson> {
        let url_ = this.baseUrl + "/api/Lessons/by-id/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLessonById(_response);
        });
    }

    protected processGetLessonById(response: Response): Promise<Lesson> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lesson;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lesson>(null as any);
    }

    updateLesson(id: number, updateRequest: AddLessonRequest): Promise<Lesson> {
        let url_ = this.baseUrl + "/api/Lessons/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLesson(_response);
        });
    }

    protected processUpdateLesson(response: Response): Promise<Lesson> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lesson;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lesson>(null as any);
    }

    deleteLesson(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Lessons/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLesson(_response);
        });
    }

    protected processDeleteLesson(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    reorderLessons(courseId: number, lessonIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Lessons/reorder/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lessonIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderLessons(_response);
        });
    }

    protected processReorderLessons(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    uploadScormPackage(id: number, file?: FileParameter | null | undefined): Promise<ScormUploadResult> {
        let url_ = this.baseUrl + "/api/Lessons/{id}/scorm-upload";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadScormPackage(_response);
        });
    }

    protected processUploadScormPackage(response: Response): Promise<ScormUploadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScormUploadResult;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScormUploadResult>(null as any);
    }
}

export interface IModulesClient {

    getModulesByCourse(courseId: number): Promise<Module[]>;

    createModule(courseId: number, request: SaveModuleRequest): Promise<Module>;

    getModuleById(id: number): Promise<Module>;

    updateModule(id: number, request: SaveModuleRequest): Promise<Module>;

    deleteModule(id: number): Promise<boolean>;

    reorderModules(courseId: number, moduleIds: number[]): Promise<boolean>;
}

export class ModulesClient extends ApiBase implements IModulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getModulesByCourse(courseId: number): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/Modules/course/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModulesByCourse(_response);
        });
    }

    protected processGetModulesByCourse(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Module[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    createModule(courseId: number, request: SaveModuleRequest): Promise<Module> {
        let url_ = this.baseUrl + "/api/Modules/course/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateModule(_response);
        });
    }

    protected processCreateModule(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Module;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    getModuleById(id: number): Promise<Module> {
        let url_ = this.baseUrl + "/api/Modules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModuleById(_response);
        });
    }

    protected processGetModuleById(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Module;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    updateModule(id: number, request: SaveModuleRequest): Promise<Module> {
        let url_ = this.baseUrl + "/api/Modules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateModule(_response);
        });
    }

    protected processUpdateModule(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Module;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    deleteModule(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Modules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteModule(_response);
        });
    }

    protected processDeleteModule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    reorderModules(courseId: number, moduleIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Modules/reorder/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderModules(_response);
        });
    }

    protected processReorderModules(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface INotificationsClient {

    getNotifications(pageSize?: number | undefined, offset?: number | undefined, unreadOnly?: boolean | undefined): Promise<FileResponse>;

    getUnreadCount(): Promise<FileResponse>;

    markAsRead(request: MarkNotificationsReadRequest): Promise<FileResponse>;
}

export class NotificationsClient extends ApiBase implements INotificationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getNotifications(pageSize?: number | undefined, offset?: number | undefined, unreadOnly?: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Notifications?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (unreadOnly === null)
            throw new globalThis.Error("The parameter 'unreadOnly' cannot be null.");
        else if (unreadOnly !== undefined)
            url_ += "unreadOnly=" + encodeURIComponent("" + unreadOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getUnreadCount(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Notifications/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadCount(_response);
        });
    }

    protected processGetUnreadCount(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    markAsRead(request: MarkNotificationsReadRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Notifications/mark-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProfessionsClient {

    list(): Promise<Profession[]>;

    create(request: SaveProfessionRequest): Promise<Profession>;

    update(id: number, request: SaveProfessionRequest): Promise<Profession>;

    delete(id: number): Promise<boolean>;
}

export class ProfessionsClient extends ApiBase implements IProfessionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    list(): Promise<Profession[]> {
        let url_ = this.baseUrl + "/api/Professions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<Profession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profession[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Profession[]>(null as any);
    }

    create(request: SaveProfessionRequest): Promise<Profession> {
        let url_ = this.baseUrl + "/api/Professions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Profession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profession;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Profession>(null as any);
    }

    update(id: number, request: SaveProfessionRequest): Promise<Profession> {
        let url_ = this.baseUrl + "/api/Professions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Profession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profession;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Profession>(null as any);
    }

    delete(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Professions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IQuizClient {

    getQuestions(lessonId: number): Promise<QuizQuestion[]>;

    saveQuestions(lessonId: number, request: SaveQuizQuestionsRequest): Promise<QuizQuestion[]>;

    getQuestionsForEditor(lessonId: number): Promise<QuizQuestion[]>;

    submitAttempt(request: SubmitQuizAttemptRequest): Promise<QuizAttempt>;

    getAttempts(lessonId: number, enrollmentId: number): Promise<QuizAttempt[]>;
}

export class QuizClient extends ApiBase implements IQuizClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getQuestions(lessonId: number): Promise<QuizQuestion[]> {
        let url_ = this.baseUrl + "/api/Quiz/{lessonId}/questions";
        if (lessonId === undefined || lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' must be defined.");
        url_ = url_.replace("{lessonId}", encodeURIComponent("" + lessonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: Response): Promise<QuizQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuizQuestion[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuizQuestion[]>(null as any);
    }

    saveQuestions(lessonId: number, request: SaveQuizQuestionsRequest): Promise<QuizQuestion[]> {
        let url_ = this.baseUrl + "/api/Quiz/{lessonId}/questions";
        if (lessonId === undefined || lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' must be defined.");
        url_ = url_.replace("{lessonId}", encodeURIComponent("" + lessonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveQuestions(_response);
        });
    }

    protected processSaveQuestions(response: Response): Promise<QuizQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuizQuestion[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuizQuestion[]>(null as any);
    }

    getQuestionsForEditor(lessonId: number): Promise<QuizQuestion[]> {
        let url_ = this.baseUrl + "/api/Quiz/{lessonId}/questions/editor";
        if (lessonId === undefined || lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' must be defined.");
        url_ = url_.replace("{lessonId}", encodeURIComponent("" + lessonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionsForEditor(_response);
        });
    }

    protected processGetQuestionsForEditor(response: Response): Promise<QuizQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuizQuestion[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuizQuestion[]>(null as any);
    }

    submitAttempt(request: SubmitQuizAttemptRequest): Promise<QuizAttempt> {
        let url_ = this.baseUrl + "/api/Quiz/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitAttempt(_response);
        });
    }

    protected processSubmitAttempt(response: Response): Promise<QuizAttempt> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuizAttempt;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuizAttempt>(null as any);
    }

    getAttempts(lessonId: number, enrollmentId: number): Promise<QuizAttempt[]> {
        let url_ = this.baseUrl + "/api/Quiz/{lessonId}/attempts/{enrollmentId}";
        if (lessonId === undefined || lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' must be defined.");
        url_ = url_.replace("{lessonId}", encodeURIComponent("" + lessonId));
        if (enrollmentId === undefined || enrollmentId === null)
            throw new globalThis.Error("The parameter 'enrollmentId' must be defined.");
        url_ = url_.replace("{enrollmentId}", encodeURIComponent("" + enrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttempts(_response);
        });
    }

    protected processGetAttempts(response: Response): Promise<QuizAttempt[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuizAttempt[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuizAttempt[]>(null as any);
    }
}

export interface IReferenceFieldsClient {

    list(workspaceId?: number | null | undefined): Promise<UserReferenceField[]>;

    create(request: SaveReferenceFieldRequest): Promise<UserReferenceField>;

    update(id: number, request: SaveReferenceFieldRequest): Promise<UserReferenceField>;

    delete(id: number): Promise<boolean>;

    getValues(userId: number): Promise<UserReferenceFieldValue[]>;

    setValue(userId: number, request: SetReferenceFieldValueRequest): Promise<FileResponse>;
}

export class ReferenceFieldsClient extends ApiBase implements IReferenceFieldsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    list(workspaceId?: number | null | undefined): Promise<UserReferenceField[]> {
        let url_ = this.baseUrl + "/api/reference-fields?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<UserReferenceField[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReferenceField[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReferenceField[]>(null as any);
    }

    create(request: SaveReferenceFieldRequest): Promise<UserReferenceField> {
        let url_ = this.baseUrl + "/api/reference-fields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<UserReferenceField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReferenceField;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReferenceField>(null as any);
    }

    update(id: number, request: SaveReferenceFieldRequest): Promise<UserReferenceField> {
        let url_ = this.baseUrl + "/api/reference-fields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<UserReferenceField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReferenceField;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReferenceField>(null as any);
    }

    delete(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/reference-fields/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getValues(userId: number): Promise<UserReferenceFieldValue[]> {
        let url_ = this.baseUrl + "/api/reference-fields/values/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetValues(_response);
        });
    }

    protected processGetValues(response: Response): Promise<UserReferenceFieldValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReferenceFieldValue[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReferenceFieldValue[]>(null as any);
    }

    setValue(userId: number, request: SetReferenceFieldValueRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/reference-fields/values/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetValue(_response);
        });
    }

    protected processSetValue(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IReportsClient {

    exportCsv(workspaceId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, tagIds?: number[] | null | undefined): Promise<FileResponse>;

    sendReminder(request: SendReminderRequest): Promise<FileResponse>;

    searchActivity(workspaceId?: number | null | undefined, search?: string | null | undefined, courseIds?: number[] | null | undefined, userIds?: number[] | null | undefined, enrollmentStatus?: number | null | undefined, tagIds?: number[] | null | undefined, groupId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;

    exportActivityCsv(workspaceId?: number | null | undefined, search?: string | null | undefined, courseIds?: number[] | null | undefined, userIds?: number[] | null | undefined, enrollmentStatus?: number | null | undefined, tagIds?: number[] | null | undefined, groupId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined): Promise<void>;

    getUserIdsByTags(tagIds?: number[] | undefined): Promise<number[]>;

    complianceSummary(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined): Promise<ComplianceSummary>;

    complianceSearch(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;

    complianceHeatmap(pivot?: string | undefined, workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined): Promise<ComplianceHeatmapCell[]>;

    complianceSnapshots(workspaceId?: number | null | undefined, days?: number | undefined, stepDays?: number | undefined): Promise<ComplianceSnapshot[]>;

    complianceExportCsv(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined): Promise<FileResponse>;

    actionQueueSearch(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;
}

export class ReportsClient extends ApiBase implements IReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    exportCsv(workspaceId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, tagIds?: number[] | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/export/csv?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportCsv(_response);
        });
    }

    protected processExportCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendReminder(request: SendReminderRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/send-reminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendReminder(_response);
        });
    }

    protected processSendReminder(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    searchActivity(workspaceId?: number | null | undefined, search?: string | null | undefined, courseIds?: number[] | null | undefined, userIds?: number[] | null | undefined, enrollmentStatus?: number | null | undefined, tagIds?: number[] | null | undefined, groupId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/Reports/activity/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (enrollmentStatus !== undefined && enrollmentStatus !== null)
            url_ += "enrollmentStatus=" + encodeURIComponent("" + enrollmentStatus) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "sortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchActivity(_response);
        });
    }

    protected processSearchActivity(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }

    exportActivityCsv(workspaceId?: number | null | undefined, search?: string | null | undefined, courseIds?: number[] | null | undefined, userIds?: number[] | null | undefined, enrollmentStatus?: number | null | undefined, tagIds?: number[] | null | undefined, groupId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Reports/activity/export/csv?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (enrollmentStatus !== undefined && enrollmentStatus !== null)
            url_ += "enrollmentStatus=" + encodeURIComponent("" + enrollmentStatus) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "sortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportActivityCsv(_response);
        });
    }

    protected processExportActivityCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserIdsByTags(tagIds?: number[] | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Reports/user-ids-by-tags?";
        if (tagIds === null)
            throw new globalThis.Error("The parameter 'tagIds' cannot be null.");
        else if (tagIds !== undefined)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserIdsByTags(_response);
        });
    }

    protected processGetUserIdsByTags(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    complianceSummary(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined): Promise<ComplianceSummary> {
        let url_ = this.baseUrl + "/api/Reports/compliance/summary?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeUngrouped === null)
            throw new globalThis.Error("The parameter 'includeUngrouped' cannot be null.");
        else if (includeUngrouped !== undefined)
            url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
        if (courseTagIds !== undefined && courseTagIds !== null)
            courseTagIds && courseTagIds.forEach(item => { url_ += "courseTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "personTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        if (startFrom !== undefined && startFrom !== null)
            url_ += "startFrom=" + encodeURIComponent(startFrom ? "" + startFrom.toISOString() : "") + "&";
        if (startTo !== undefined && startTo !== null)
            url_ += "startTo=" + encodeURIComponent(startTo ? "" + startTo.toISOString() : "") + "&";
        if (dueFrom !== undefined && dueFrom !== null)
            url_ += "dueFrom=" + encodeURIComponent(dueFrom ? "" + dueFrom.toISOString() : "") + "&";
        if (dueTo !== undefined && dueTo !== null)
            url_ += "dueTo=" + encodeURIComponent(dueTo ? "" + dueTo.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplianceSummary(_response);
        });
    }

    protected processComplianceSummary(response: Response): Promise<ComplianceSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceSummary;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComplianceSummary>(null as any);
    }

    complianceSearch(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/Reports/compliance/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeUngrouped === null)
            throw new globalThis.Error("The parameter 'includeUngrouped' cannot be null.");
        else if (includeUngrouped !== undefined)
            url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
        if (courseTagIds !== undefined && courseTagIds !== null)
            courseTagIds && courseTagIds.forEach(item => { url_ += "courseTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "personTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        if (startFrom !== undefined && startFrom !== null)
            url_ += "startFrom=" + encodeURIComponent(startFrom ? "" + startFrom.toISOString() : "") + "&";
        if (startTo !== undefined && startTo !== null)
            url_ += "startTo=" + encodeURIComponent(startTo ? "" + startTo.toISOString() : "") + "&";
        if (dueFrom !== undefined && dueFrom !== null)
            url_ += "dueFrom=" + encodeURIComponent(dueFrom ? "" + dueFrom.toISOString() : "") + "&";
        if (dueTo !== undefined && dueTo !== null)
            url_ += "dueTo=" + encodeURIComponent(dueTo ? "" + dueTo.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "sortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplianceSearch(_response);
        });
    }

    protected processComplianceSearch(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }

    complianceHeatmap(pivot?: string | undefined, workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined): Promise<ComplianceHeatmapCell[]> {
        let url_ = this.baseUrl + "/api/Reports/compliance/heatmap?";
        if (pivot === null)
            throw new globalThis.Error("The parameter 'pivot' cannot be null.");
        else if (pivot !== undefined)
            url_ += "pivot=" + encodeURIComponent("" + pivot) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeUngrouped === null)
            throw new globalThis.Error("The parameter 'includeUngrouped' cannot be null.");
        else if (includeUngrouped !== undefined)
            url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
        if (courseTagIds !== undefined && courseTagIds !== null)
            courseTagIds && courseTagIds.forEach(item => { url_ += "courseTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "personTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        if (startFrom !== undefined && startFrom !== null)
            url_ += "startFrom=" + encodeURIComponent(startFrom ? "" + startFrom.toISOString() : "") + "&";
        if (startTo !== undefined && startTo !== null)
            url_ += "startTo=" + encodeURIComponent(startTo ? "" + startTo.toISOString() : "") + "&";
        if (dueFrom !== undefined && dueFrom !== null)
            url_ += "dueFrom=" + encodeURIComponent(dueFrom ? "" + dueFrom.toISOString() : "") + "&";
        if (dueTo !== undefined && dueTo !== null)
            url_ += "dueTo=" + encodeURIComponent(dueTo ? "" + dueTo.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplianceHeatmap(_response);
        });
    }

    protected processComplianceHeatmap(response: Response): Promise<ComplianceHeatmapCell[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceHeatmapCell[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComplianceHeatmapCell[]>(null as any);
    }

    complianceSnapshots(workspaceId?: number | null | undefined, days?: number | undefined, stepDays?: number | undefined): Promise<ComplianceSnapshot[]> {
        let url_ = this.baseUrl + "/api/Reports/compliance/snapshots?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (days === null)
            throw new globalThis.Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (stepDays === null)
            throw new globalThis.Error("The parameter 'stepDays' cannot be null.");
        else if (stepDays !== undefined)
            url_ += "stepDays=" + encodeURIComponent("" + stepDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplianceSnapshots(_response);
        });
    }

    protected processComplianceSnapshots(response: Response): Promise<ComplianceSnapshot[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceSnapshot[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComplianceSnapshot[]>(null as any);
    }

    complianceExportCsv(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, assignmentStatus?: number | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, sortKey?: string | null | undefined, sortDescending?: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/compliance/export/csv?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeUngrouped === null)
            throw new globalThis.Error("The parameter 'includeUngrouped' cannot be null.");
        else if (includeUngrouped !== undefined)
            url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
        if (courseTagIds !== undefined && courseTagIds !== null)
            courseTagIds && courseTagIds.forEach(item => { url_ += "courseTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "personTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        if (startFrom !== undefined && startFrom !== null)
            url_ += "startFrom=" + encodeURIComponent(startFrom ? "" + startFrom.toISOString() : "") + "&";
        if (startTo !== undefined && startTo !== null)
            url_ += "startTo=" + encodeURIComponent(startTo ? "" + startTo.toISOString() : "") + "&";
        if (dueFrom !== undefined && dueFrom !== null)
            url_ += "dueFrom=" + encodeURIComponent(dueFrom ? "" + dueFrom.toISOString() : "") + "&";
        if (dueTo !== undefined && dueTo !== null)
            url_ += "dueTo=" + encodeURIComponent(dueTo ? "" + dueTo.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "sortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplianceExportCsv(_response);
        });
    }

    protected processComplianceExportCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    actionQueueSearch(workspaceId?: number | null | undefined, userIds?: number[] | null | undefined, courseIds?: number[] | null | undefined, groupIds?: number[] | null | undefined, includeUngrouped?: boolean | undefined, courseTagIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, startFrom?: Date | null | undefined, startTo?: Date | null | undefined, dueFrom?: Date | null | undefined, dueTo?: Date | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/Reports/actionqueue/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(item => { url_ += "groupIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeUngrouped === null)
            throw new globalThis.Error("The parameter 'includeUngrouped' cannot be null.");
        else if (includeUngrouped !== undefined)
            url_ += "includeUngrouped=" + encodeURIComponent("" + includeUngrouped) + "&";
        if (courseTagIds !== undefined && courseTagIds !== null)
            courseTagIds && courseTagIds.forEach(item => { url_ += "courseTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "personTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (startFrom !== undefined && startFrom !== null)
            url_ += "startFrom=" + encodeURIComponent(startFrom ? "" + startFrom.toISOString() : "") + "&";
        if (startTo !== undefined && startTo !== null)
            url_ += "startTo=" + encodeURIComponent(startTo ? "" + startTo.toISOString() : "") + "&";
        if (dueFrom !== undefined && dueFrom !== null)
            url_ += "dueFrom=" + encodeURIComponent(dueFrom ? "" + dueFrom.toISOString() : "") + "&";
        if (dueTo !== undefined && dueTo !== null)
            url_ += "dueTo=" + encodeURIComponent(dueTo ? "" + dueTo.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActionQueueSearch(_response);
        });
    }

    protected processActionQueueSearch(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }
}

export interface IStorageClient {

    getFileUrl(url?: string | undefined): Promise<string>;

    generateSas(extension?: string | null | undefined): Promise<SasUploadResult>;

    generateVideoUpload(request: CreateVideoUploadRequest): Promise<VideoUploadResponse>;

    getVideoPlayback(lessonId?: number | undefined): Promise<VideoPlaybackResponse>;

    getDetailVideoPlayback(courseId?: number | undefined): Promise<VideoPlaybackResponse>;
}

export class StorageClient extends ApiBase implements IStorageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    getFileUrl(url?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Storage/get-file-url?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    generateSas(extension?: string | null | undefined): Promise<SasUploadResult> {
        let url_ = this.baseUrl + "/api/Storage/generate-sas?";
        if (extension !== undefined && extension !== null)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateSas(_response);
        });
    }

    protected processGenerateSas(response: Response): Promise<SasUploadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SasUploadResult;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SasUploadResult>(null as any);
    }

    generateVideoUpload(request: CreateVideoUploadRequest): Promise<VideoUploadResponse> {
        let url_ = this.baseUrl + "/api/Storage/generate-video-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateVideoUpload(_response);
        });
    }

    protected processGenerateVideoUpload(response: Response): Promise<VideoUploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VideoUploadResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoUploadResponse>(null as any);
    }

    getVideoPlayback(lessonId?: number | undefined): Promise<VideoPlaybackResponse> {
        let url_ = this.baseUrl + "/api/Storage/get-video-playback?";
        if (lessonId === null)
            throw new globalThis.Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVideoPlayback(_response);
        });
    }

    protected processGetVideoPlayback(response: Response): Promise<VideoPlaybackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VideoPlaybackResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaybackResponse>(null as any);
    }

    getDetailVideoPlayback(courseId?: number | undefined): Promise<VideoPlaybackResponse> {
        let url_ = this.baseUrl + "/api/Storage/get-detail-video-playback?";
        if (courseId === null)
            throw new globalThis.Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetailVideoPlayback(_response);
        });
    }

    protected processGetDetailVideoPlayback(response: Response): Promise<VideoPlaybackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VideoPlaybackResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaybackResponse>(null as any);
    }
}

export interface ITagsClient {

    searchTags(search?: string | null | undefined, type?: TagType | null | undefined, workspaceId?: number | null | undefined, includeAccountWide?: boolean | undefined, accountWideOnly?: boolean | undefined, ids?: number[] | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfTag>;

    getTagById(id: number): Promise<Tag>;

    updateTag(id: number, request: SaveTagRequest): Promise<Tag>;

    deleteTag(id: number): Promise<boolean>;

    createTag(request: SaveTagRequest): Promise<Tag>;

    addUsersToTag(id: number, request: AddUsersToTagRequest): Promise<FileResponse>;

    removeUsersFromTag(id: number, request: AddUsersToTagRequest): Promise<FileResponse>;

    getTagUsers(id: number): Promise<UserTag[]>;

    getUserTags(userId: number): Promise<UserTag[]>;
}

export class TagsClient extends ApiBase implements ITagsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchTags(search?: string | null | undefined, type?: TagType | null | undefined, workspaceId?: number | null | undefined, includeAccountWide?: boolean | undefined, accountWideOnly?: boolean | undefined, ids?: number[] | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfTag> {
        let url_ = this.baseUrl + "/api/Tags/search?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (includeAccountWide === null)
            throw new globalThis.Error("The parameter 'includeAccountWide' cannot be null.");
        else if (includeAccountWide !== undefined)
            url_ += "includeAccountWide=" + encodeURIComponent("" + includeAccountWide) + "&";
        if (accountWideOnly === null)
            throw new globalThis.Error("The parameter 'accountWideOnly' cannot be null.");
        else if (accountWideOnly !== undefined)
            url_ += "accountWideOnly=" + encodeURIComponent("" + accountWideOnly) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchTags(_response);
        });
    }

    protected processSearchTags(response: Response): Promise<PagedResultOfTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfTag;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfTag>(null as any);
    }

    getTagById(id: number): Promise<Tag> {
        let url_ = this.baseUrl + "/api/Tags/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagById(_response);
        });
    }

    protected processGetTagById(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    updateTag(id: number, request: SaveTagRequest): Promise<Tag> {
        let url_ = this.baseUrl + "/api/Tags/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTag(_response);
        });
    }

    protected processUpdateTag(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    deleteTag(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tags/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTag(_response);
        });
    }

    protected processDeleteTag(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createTag(request: SaveTagRequest): Promise<Tag> {
        let url_ = this.baseUrl + "/api/Tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTag(_response);
        });
    }

    protected processCreateTag(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    addUsersToTag(id: number, request: AddUsersToTagRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tags/{id}/users";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUsersToTag(_response);
        });
    }

    protected processAddUsersToTag(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeUsersFromTag(id: number, request: AddUsersToTagRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tags/{id}/users";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUsersFromTag(_response);
        });
    }

    protected processRemoveUsersFromTag(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTagUsers(id: number): Promise<UserTag[]> {
        let url_ = this.baseUrl + "/api/Tags/{id}/users";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagUsers(_response);
        });
    }

    protected processGetTagUsers(response: Response): Promise<UserTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserTag[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTag[]>(null as any);
    }

    getUserTags(userId: number): Promise<UserTag[]> {
        let url_ = this.baseUrl + "/api/Tags/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTags(_response);
        });
    }

    protected processGetUserTags(response: Response): Promise<UserTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserTag[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTag[]>(null as any);
    }
}

export interface IUserAssignmentsClient {

    searchAllUserAssignments(workspaceId?: number | null | undefined, assignmentStatus?: number | null | undefined, enrollmentStatus?: number | null | undefined, courseId?: number | null | undefined, userId?: number | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment>;

    getAssignmentCount(workspaceId?: number | null | undefined, assignmentStatus?: number | null | undefined): Promise<number>;
}

export class UserAssignmentsClient extends ApiBase implements IUserAssignmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchAllUserAssignments(workspaceId?: number | null | undefined, assignmentStatus?: number | null | undefined, enrollmentStatus?: number | null | undefined, courseId?: number | null | undefined, userId?: number | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<PagedResultOfCourseEnrollment> {
        let url_ = this.baseUrl + "/api/UserAssignments/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        if (enrollmentStatus !== undefined && enrollmentStatus !== null)
            url_ += "enrollmentStatus=" + encodeURIComponent("" + enrollmentStatus) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAllUserAssignments(_response);
        });
    }

    protected processSearchAllUserAssignments(response: Response): Promise<PagedResultOfCourseEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfCourseEnrollment;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCourseEnrollment>(null as any);
    }

    getAssignmentCount(workspaceId?: number | null | undefined, assignmentStatus?: number | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/UserAssignments/count?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (assignmentStatus !== undefined && assignmentStatus !== null)
            url_ += "assignmentStatus=" + encodeURIComponent("" + assignmentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentCount(_response);
        });
    }

    protected processGetAssignmentCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IUsersClient {

    searchUsersPaged(workspaceId?: number | null | undefined, role?: number | null | undefined, status?: string | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, excludeIds?: number[] | null | undefined, emails?: string[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfLogin>;

    getUserById(id: number): Promise<Login>;

    updateUser(id: number, request: UpdateUserRequest): Promise<Login>;

    deleteUser(id: number): Promise<boolean>;

    createUser(request: CreateUserRequest): Promise<Login>;

    inviteUser(request: InviteUserRequest): Promise<InvitationResponse>;

    bulkInviteUsers(request: BulkInviteUsersRequest): Promise<InvitationResponse[]>;

    getPendingInvitations(): Promise<InvitationResponse[]>;

    resendInvitation(id: number): Promise<boolean>;

    cancelInvitation(id: number): Promise<boolean>;

    reactivateUser(id: number): Promise<boolean>;

    toggleUserStatus(id: number, newStatus?: boolean | null | undefined): Promise<Login>;

    resetUserPassword(id: number, request: ResetUserPasswordRequest): Promise<boolean>;
}

export class UsersClient extends ApiBase implements IUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchUsersPaged(workspaceId?: number | null | undefined, role?: number | null | undefined, status?: string | null | undefined, search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, excludeIds?: number[] | null | undefined, emails?: string[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfLogin> {
        let url_ = this.baseUrl + "/api/Users/search?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        if (emails !== undefined && emails !== null)
            emails && emails.forEach(item => { url_ += "emails=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUsersPaged(_response);
        });
    }

    protected processSearchUsersPaged(response: Response): Promise<PagedResultOfLogin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfLogin;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfLogin>(null as any);
    }

    getUserById(id: number): Promise<Login> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Login;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    updateUser(id: number, request: UpdateUserRequest): Promise<Login> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Login;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    deleteUser(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createUser(request: CreateUserRequest): Promise<Login> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Login;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    inviteUser(request: InviteUserRequest): Promise<InvitationResponse> {
        let url_ = this.baseUrl + "/api/Users/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<InvitationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationResponse;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationResponse>(null as any);
    }

    bulkInviteUsers(request: BulkInviteUsersRequest): Promise<InvitationResponse[]> {
        let url_ = this.baseUrl + "/api/Users/bulk-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkInviteUsers(_response);
        });
    }

    protected processBulkInviteUsers(response: Response): Promise<InvitationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationResponse[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationResponse[]>(null as any);
    }

    getPendingInvitations(): Promise<InvitationResponse[]> {
        let url_ = this.baseUrl + "/api/Users/invitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPendingInvitations(_response);
        });
    }

    protected processGetPendingInvitations(response: Response): Promise<InvitationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationResponse[];
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationResponse[]>(null as any);
    }

    resendInvitation(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/invitations/{id}/resend";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendInvitation(_response);
        });
    }

    protected processResendInvitation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    cancelInvitation(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/invitations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelInvitation(_response);
        });
    }

    protected processCancelInvitation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    reactivateUser(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/{id}/reactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivateUser(_response);
        });
    }

    protected processReactivateUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    toggleUserStatus(id: number, newStatus?: boolean | null | undefined): Promise<Login> {
        let url_ = this.baseUrl + "/api/Users/{id}/toggle-status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newStatus !== undefined && newStatus !== null)
            url_ += "newStatus=" + encodeURIComponent("" + newStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToggleUserStatus(_response);
        });
    }

    protected processToggleUserStatus(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Login;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    resetUserPassword(id: number, request: ResetUserPasswordRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/{id}/reset-password";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetUserPassword(_response);
        });
    }

    protected processResetUserPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IWebhooksClient {

    handleMuxWebhook(): Promise<FileResponse>;
}

export class WebhooksClient extends ApiBase implements IWebhooksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    handleMuxWebhook(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Webhooks/mux";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandleMuxWebhook(_response);
        });
    }

    protected processHandleMuxWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IWorkspacesClient {

    searchWorkspaces(search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfWorkspace>;

    getWorkspaceById(id: number): Promise<Workspace>;

    updateWorkspace(id: number, request: UpdateWorkspaceRequest): Promise<Workspace>;

    deleteWorkspace(id: number): Promise<boolean>;

    createWorkspace(request: AddWorkspaceRequest): Promise<Workspace>;

    updateWorkspaceAccess(id: number, request: UpdateWorkspaceAccessRequest): Promise<Workspace>;

    setWorkspaceStatus(id: number, request: SetWorkspaceStatusRequest): Promise<Workspace>;

    getMyWorkspaceBranding(): Promise<Workspace>;
}

export class WorkspacesClient extends ApiBase implements IWorkspacesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7285";
    }

    searchWorkspaces(search?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined, ids?: number[] | null | undefined, sortBy?: string | null | undefined, sortDir?: string | null | undefined): Promise<PagedResultOfWorkspace> {
        let url_ = this.baseUrl + "/api/Workspaces/search?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "sortDir=" + encodeURIComponent("" + sortDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchWorkspaces(_response);
        });
    }

    protected processSearchWorkspaces(response: Response): Promise<PagedResultOfWorkspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultOfWorkspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfWorkspace>(null as any);
    }

    getWorkspaceById(id: number): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkspaceById(_response);
        });
    }

    protected processGetWorkspaceById(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }

    updateWorkspace(id: number, request: UpdateWorkspaceRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWorkspace(_response);
        });
    }

    protected processUpdateWorkspace(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }

    deleteWorkspace(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Workspaces/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteWorkspace(_response);
        });
    }

    protected processDeleteWorkspace(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createWorkspace(request: AddWorkspaceRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWorkspace(_response);
        });
    }

    protected processCreateWorkspace(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }

    updateWorkspaceAccess(id: number, request: UpdateWorkspaceAccessRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces/{id}/access";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWorkspaceAccess(_response);
        });
    }

    protected processUpdateWorkspaceAccess(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }

    setWorkspaceStatus(id: number, request: SetWorkspaceStatusRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetWorkspaceStatus(_response);
        });
    }

    protected processSetWorkspaceStatus(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }

    getMyWorkspaceBranding(): Promise<Workspace> {
        let url_ = this.baseUrl + "/api/Workspaces/my-workspace-branding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyWorkspaceBranding(_response);
        });
    }

    protected processGetMyWorkspaceBranding(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status >= 200 && status < 300) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workspace;
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(null as any);
    }
}

export interface AssignmentDefinition {
    id?: number;
    courseId?: number;
    courseTitle?: string | undefined;
    startDate?: Date | undefined;
    deadline?: Date;
    targetUserIds?: number[] | undefined;
    targetTagIds?: number[] | undefined;
    targetGroupIds?: number[] | undefined;
    accountId?: number | undefined;
    workspaceId?: number | undefined;
    assignedBy?: number;
    createdAt?: Date;
    updatedAt?: Date;
    status?: AssignmentDefinitionStatus;
    isOnboardingOnly?: boolean;
    targetProfessionIds?: number[] | undefined;
    isActive?: boolean;
    isExpired?: boolean;
    isUpcoming?: boolean;
    targetsUsers?: boolean;
    targetsTags?: boolean;
    targetsGroups?: boolean;
    targetsProfessions?: boolean;
    totalTargetedUsers?: number;
    totalTargetedTags?: number;
    totalTargetedGroups?: number;
    totalTargetedProfessions?: number;
}

export enum AssignmentDefinitionStatus {
    Draft = 1,
    Active = 2,
    Archived = 3,
}

export interface UpdateAssignmentDefinitionRequest {
    startDate?: Date | undefined;
    deadline?: Date | undefined;
    targetUserIds?: number[] | undefined;
    targetTagIds?: number[] | undefined;
    targetGroupIds?: number[] | undefined;
    isOnboardingOnly?: boolean | undefined;
    targetProfessionIds?: number[] | undefined;
}

export interface CloneAssignmentDefinitionRequest {
    startDate?: Date | undefined;
    deadline?: Date | undefined;
    targetUserIds?: number[] | undefined;
    targetTagIds?: number[] | undefined;
    targetGroupIds?: number[] | undefined;
}

export interface SignupResponse {
    success?: boolean;
    userId?: number;
}

export interface SignupRequest {
    accountId?: number;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
    role?: number;
}

export interface LoginResponse {
    success?: boolean;
    token?: string;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface LoginRequest {
    email?: string;
    password?: string;
}

export interface CheckSessionResponse {
    success?: boolean;
    message?: string;
    userId?: string;
    role?: string;
}

export interface Account {
    id?: number;
    name?: string | undefined;
    logoUrl?: string | undefined;
    primaryColor?: string | undefined;
    domain?: string | undefined;
    favicon?: string | undefined;
    bannerHtml?: string | undefined;
    internalName?: string | undefined;
    url?: string | undefined;
}

export interface MessageResponse {
    success?: boolean;
    message?: string;
}

export interface SendCodeRequest {
    email?: string;
}

export interface VerifyCodeRequest {
    code?: string;
    email?: string;
}

export interface ForgotPasswordRequest {
    code?: string;
    newPassword?: string;
    email?: string;
}

export interface UserInfoDto {
    id?: number;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: UserRole | undefined;
    createdAt?: Date | undefined;
    workspaceId?: number | undefined;
    accountId?: number | undefined;
    profileImageUrl?: string | undefined;
    jobTitle?: string | undefined;
}

export enum UserRole {
    Admin = 1,
    User = 2,
    AccountAdmin = 3,
    WorkspaceAdmin = 4,
}

export interface AcceptInviteResponse {
    success?: boolean;
    message?: string;
    token?: string;
    user?: UserBasicInfo;
}

export interface UserBasicInfo {
    id?: number;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface AcceptInvitationRequest {
    token: string;
    password: string;
    confirmPassword: string;
}

export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export interface UpdateProfileResponse {
    success?: boolean;
    message?: string;
    user?: UserBasicInfo;
}

export interface UpdateProfileRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface ImpersonateResponse {
    success?: boolean;
    token?: string;
}

export interface Certificate {
    id?: number;
    accountId?: number;
    enrollmentId?: number;
    userId?: number;
    courseId?: number;
    templateId?: number | undefined;
    studentName?: string;
    courseTitle?: string;
    completedAt?: Date;
    imageFilename?: string;
    createdAt?: Date;
}

export interface EmailCertificateRequest {
    email?: string;
}

export interface CertificateTemplate {
    id?: number;
    accountId?: number;
    workspaceId?: number | undefined;
    name?: string;
    backgroundImage?: string | undefined;
    width?: number;
    height?: number;
    textFields?: CertificateTextField[];
    isActive?: boolean;
    createdBy?: number;
    createdAt?: Date;
    updatedAt?: Date;
    signatureImage?: string | undefined;
    signatureX?: number;
    signatureY?: number;
    signatureWidth?: number;
    signatureHeight?: number;
}

export interface CertificateTextField {
    fieldType?: string;
    x?: number;
    y?: number;
    fontSize?: number;
    fontFamily?: string;
    fontColor?: string;
    fontWeight?: string;
    textAlign?: string;
    content?: string | undefined;
}

export interface SaveCertificateTemplateRequest {
    id?: number | undefined;
    name?: string;
    backgroundImage?: string | undefined;
    width?: number;
    height?: number;
    textFields?: CertificateTextField[];
    isActive?: boolean;
    signatureImage?: string | undefined;
    signatureX?: number;
    signatureY?: number;
    signatureWidth?: number;
    signatureHeight?: number;
}

export interface CourseAuthor {
    id?: number;
    accountId?: number;
    name?: string;
    credentials?: string | undefined;
    bio?: string | undefined;
    portraitUrl?: string | undefined;
    portraitFocalX?: number | undefined;
    portraitFocalY?: number | undefined;
    quote?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface SaveCourseAuthorRequest {
    name?: string;
    credentials?: string | undefined;
    bio?: string | undefined;
    portraitUrl?: string | undefined;
    portraitFocalX?: number | undefined;
    portraitFocalY?: number | undefined;
    quote?: string | undefined;
}

export interface CourseCustomField {
    id?: number;
    accountId?: number;
    name?: string;
    fieldType?: CourseCustomFieldType;
    options?: string[] | undefined;
    sequenceOrder?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum CourseCustomFieldType {
    Text = 1,
    Number = 2,
    Select = 3,
}

export interface SaveCourseCustomFieldRequest {
    name?: string;
    fieldType?: CourseCustomFieldType;
    options?: string[] | undefined;
    sequenceOrder?: number;
}

export interface CourseCustomFieldValue {
    id?: number;
    courseId?: number;
    fieldId?: number;
    value?: string[] | undefined;
}

export interface SetCourseCustomFieldValueRequest {
    fieldId?: number;
    value?: string[] | undefined;
}

export interface CourseDetailTab {
    id?: number;
    courseId?: number;
    title?: string;
    contentHtml?: string | undefined;
    sequenceOrder?: number;
    isDeleted?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface PagedResultOfCourseEnrollment {
    items?: CourseEnrollment[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface CourseEnrollment {
    enrollmentId?: number | undefined;
    userId?: number;
    courseId?: number;
    courseTitle?: string | undefined;
    courseSlug?: string | undefined;
    courseType?: CourseType | undefined;
    courseDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    workspaceId?: number | undefined;
    assignmentDefinitionId?: number | undefined;
    assignmentCreatedAt?: Date | undefined;
    startDate?: Date | undefined;
    deadline?: Date | undefined;
    assignedBy?: number | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    lastAccessedAt?: Date | undefined;
    enrollmentCreatedAt?: Date | undefined;
    revokedAt?: Date | undefined;
    enrollmentStatus?: EnrollmentStatus;
    assignmentStatus?: AssignmentStatus | undefined;
    progressPercentage?: number;
    completedTaskCount?: number;
    totalTaskCount?: number;
    certificateId?: number | undefined;
    isAssigned?: boolean;
    isStarted?: boolean;
    hasDeadline?: boolean;
    isOverdue?: boolean;
    isCompleted?: boolean;
    isRevoked?: boolean;
    id?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum CourseType {
    Standard = 1,
    External = 2,
    LearningPath = 3,
}

export enum EnrollmentStatus {
    NotStarted = 1,
    InProgress = 2,
    Completed = 3,
}

export enum AssignmentStatus {
    Upcoming = 1,
    Active = 2,
    Overdue = 3,
    Completed = 4,
}

export interface CreateEnrollmentRequest {
    userId?: number;
    courseId?: number;
}

export interface StartCourseRequest {
    userId?: number;
    courseId?: number;
}

export interface CompleteExternalCourseRequest {
    userId?: number;
    courseId?: number;
}

export interface AdminCompleteCourseRequest {
    userId?: number;
    courseId?: number;
}

export interface Course {
    id?: number;
    workspaceId?: number | undefined;
    accountId?: number | undefined;
    userId?: number;
    title?: string | undefined;
    thumbnail?: string | undefined;
    description?: string | undefined;
    tagIds?: number[] | undefined;
    tags?: Tag[];
    currentUserEnrollment?: CourseEnrollment | undefined;
    deletedBy?: boolean | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isDeleted?: boolean;
    isDraft?: boolean;
    publishedDate?: Date | undefined;
    enforceLinearProgress?: boolean;
    slug?: string | undefined;
    isPublic?: boolean;
    courseType?: CourseType;
    externalUrl?: string | undefined;
    eventDate?: Date | undefined;
    pathCourses?: LearningPathCourse[];
    totalPathCourses?: number;
    completedPathCourses?: number;
    detailVideoId?: number | undefined;
    detailVideo?: VideoAsset | undefined;
    detailImageUrl?: string | undefined;
    detailImageAltText?: string | undefined;
    detailVideoUrl?: string | undefined;
    detailVideoUrlEnabled?: boolean;
    detailTabs?: CourseDetailTab[];
    displayModuleNames?: boolean;
    instructorMessagingEnabled?: boolean;
    instructorMessagingEmail?: string | undefined;
    ceInfoEnabled?: boolean;
    ceHours?: number | undefined;
    issuesCertificate?: boolean;
    courseCode?: string | undefined;
    authorId?: number | undefined;
    ceInfo?: CourseCeInfo | undefined;
    eventVerification?: CourseEventVerification | undefined;
    modules?: Module[];
    lessons?: Lesson[];
}

export interface Tag {
    id?: number;
    name?: string;
    tagType?: TagType;
    accountId?: number | undefined;
    workspaceId?: number | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum TagType {
    UserTag = 1,
    CourseTag = 2,
}

export interface LearningPathCourse {
    id?: number;
    learningPathId?: number;
    courseId?: number;
    sequenceOrder?: number;
    createdAt?: Date;
    courseTitle?: string | undefined;
    courseThumbnail?: string | undefined;
    courseDescription?: string | undefined;
    courseSlug?: string | undefined;
    courseType?: CourseType;
    userCourseEnrollment?: CourseEnrollment | undefined;
}

export interface VideoAsset {
    id?: number;
    provider?: VideoProvider | undefined;
    muxUploadId?: string | undefined;
    muxAssetId?: string | undefined;
    muxPlaybackId?: string | undefined;
    externalId?: string | undefined;
    duration?: number | undefined;
    status?: string | undefined;
    posterUrl?: string | undefined;
    isDeleted?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum VideoProvider {
    Mux = 1,
    Wistia = 2,
}

export interface CourseCeInfo {
    agdSubjectCode?: string | undefined;
    paceProviderId?: string | undefined;
    educationalMethod?: string | undefined;
    location?: string | undefined;
    accreditationStatement?: string | undefined;
    disclosureStatement?: string | undefined;
    paceBadgeUrl?: string | undefined;
}

export interface CourseEventVerification {
    codeEnabled?: boolean;
    code?: string | undefined;
    attestationEnabled?: boolean;
    attestationText?: string | undefined;
    adminMarkedEnabled?: boolean;
    webinarApiEnabled?: boolean;
}

export interface Module {
    id?: number;
    courseId?: number;
    title?: string;
    description?: string | undefined;
    sequenceOrder?: number;
    accountId?: number | undefined;
    isDeleted?: boolean;
    createdAt?: Date;
    updatedAt?: Date | undefined;
}

export interface Lesson {
    id?: number;
    accountId?: number | undefined;
    userId?: number;
    courseId?: number;
    title?: string;
    description?: string | undefined;
    thumbnail?: string | undefined;
    lessonType?: LessonType;
    attachedUrl?: string | undefined;
    videoUrl?: string;
    file?: string | undefined;
    textContent?: string | undefined;
    isDeleted?: boolean | undefined;
    sequenceOrder?: number;
    moduleId?: number | undefined;
    isRequired?: boolean;
    minWatchPercent?: number | undefined;
    isGated?: boolean;
    muxUploadId?: string | undefined;
    muxAssetId?: string | undefined;
    muxPlaybackId?: string | undefined;
    videoDuration?: number | undefined;
    videoStatus?: string | undefined;
    videoProvider?: VideoProvider | undefined;
    externalVideoId?: string | undefined;
    videoPosterUrl?: string | undefined;
    scormPackageGuid?: string | undefined;
    scormPackageUrl?: string | undefined;
    scormEntryPoint?: string | undefined;
    scormSourceFilename?: string | undefined;
    quizSettings?: QuizSettings | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
}

export enum LessonType {
    Video = 1,
    PPT = 2,
    Word = 3,
    Text = 4,
    PDF = 5,
    Quiz = 6,
    Scorm = 7,
}

export interface QuizSettings {
    id?: number;
    lessonId?: number;
    passThreshold?: number | undefined;
    maxAttempts?: number | undefined;
    timeLimitSeconds?: number | undefined;
    randomizeChoices?: boolean;
    subsetSize?: number | undefined;
    allowResume?: boolean;
    preventProgression?: boolean;
    hideResults?: boolean;
    startMessage?: string | undefined;
    passMessage?: string | undefined;
    failMessage?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface AddCourseRequest {
    accountId?: number | undefined;
    title?: string;
    thumbnail?: string | undefined;
    description?: string | undefined;
    tagIds?: number[] | undefined;
    isDraft?: boolean;
    enforceLinearProgress?: boolean;
    isPublic?: boolean | undefined;
    courseType?: CourseType;
    externalUrl?: string | undefined;
    eventDate?: Date | undefined;
    pathCourses?: PathCourseItem[] | undefined;
    detailImageUrl?: string | undefined;
    detailImageAltText?: string | undefined;
    detailVideoProvider?: VideoProvider | undefined;
    detailVideoExternalId?: string | undefined;
    detailTabs?: DetailTabItem[] | undefined;
    settings?: CourseSettings | undefined;
}

export interface PathCourseItem {
    courseId?: number;
    sequenceOrder?: number;
}

export interface DetailTabItem {
    id?: number;
    title?: string;
    contentHtml?: string | undefined;
}

export interface CourseSettings {
    displayModuleNames?: boolean;
    instructorMessagingEnabled?: boolean;
    instructorMessagingEmail?: string | undefined;
    ceInfoEnabled?: boolean;
    ceHours?: number | undefined;
    issuesCertificate?: boolean;
    courseCode?: string | undefined;
    authorId?: number | undefined;
    detailVideoUrl?: string | undefined;
    detailVideoUrlEnabled?: boolean;
    ceInfo?: CourseCeInfo | undefined;
    eventVerification?: CourseEventVerification | undefined;
}

export interface VideoAssetUploadTicket {
    videoAssetId?: number;
    uploadUrl?: string;
}

export interface AddPathCourseRequest {
    courseId?: number;
    sequenceOrder?: number;
}

export interface ReorderPathCoursesRequest {
    courseIds?: number[];
}

export interface PagedResultOfGroup {
    items?: Group[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface Group {
    id?: number;
    name?: string;
    description?: string | undefined;
    workspaceId?: number;
    accountId?: number;
    ownerUserId?: number | undefined;
    ownerName?: string | undefined;
    createdByUserId?: number;
    createdAt?: Date;
    updatedAt?: Date;
    memberCount?: number;
    adminCount?: number;
    workspaceName?: string | undefined;
    seatLimit?: number | undefined;
    customizeContent?: boolean;
    primaryColor?: string | undefined;
    logoUrl?: string | undefined;
    contentTagIds?: number[];
    provisionedCourseIds?: number[];
}

export interface UserGroup {
    userId?: number;
    groupId?: number;
    createdAt?: Date;
    userEmail?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    groupName?: string | undefined;
    isOwner?: boolean;
}

export interface SaveGroupRequest {
    name?: string;
    workspaceId?: number;
    description?: string | undefined;
    ownerUserId?: number | undefined;
}

export interface UpdateGroupAccessRequest {
    seatLimit?: number | undefined;
    customizeContent?: boolean;
    primaryColor?: string | undefined;
    logoUrl?: string | undefined;
    contentTagIds?: number[] | undefined;
    provisionedCourseIds?: number[] | undefined;
}

export interface ManageGroupMembersRequest {
    userIds?: number[];
}

export interface ChangeGroupOwnerRequest {
    ownerUserId?: number | undefined;
}

export interface SetProfessionRequest {
    professionId?: number | undefined;
}

export interface LearnerLicense {
    id?: number;
    loginId?: number;
    state?: string;
    customStateName?: string | undefined;
    licenseNumber?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface SaveLearnerLicenseRequest {
    state?: string;
    customStateName?: string | undefined;
    licenseNumber?: string;
}

export interface SaveLearnerLicensesRequest {
    licenses?: LearnerLicenseItem[];
}

export interface LearnerLicenseItem {
    id?: number | undefined;
    state?: string;
    customStateName?: string | undefined;
    licenseNumber?: string;
}

export interface LessonCompletion {
    id?: number;
    enrollmentId?: number;
    lessonId?: number;
    completedAt?: Date;
    createdAt?: Date;
}

export interface MarkLessonCompleteRequest {
    enrollmentId?: number | undefined;
    lessonId?: number;
}

export interface AddLessonRequest {
    accountId?: number | undefined;
    title?: string;
    lessonType?: LessonType;
    description?: string | undefined;
    thumbnail?: string | undefined;
    videUrl?: string | undefined;
    attachedUrl?: string | undefined;
    file?: string | undefined;
    textContent?: string | undefined;
    moduleId?: number | undefined;
    videoProvider?: VideoProvider | undefined;
    externalVideoId?: string | undefined;
    quizSettings?: QuizSettings | undefined;
    isRequired?: boolean | undefined;
    minWatchPercent?: number | undefined;
    isGated?: boolean | undefined;
}

export interface ScormUploadResult {
    lessonId?: number;
    packageUrl?: string;
    entryPoint?: string;
    fileCount?: number;
    reused?: boolean;
}

export interface SaveModuleRequest {
    title?: string;
    description?: string | undefined;
}

export interface MarkNotificationsReadRequest {
    notificationIds?: number[];
}

export interface Profession {
    id?: number;
    accountId?: number;
    name?: string;
    sequenceOrder?: number;
    isLicensed?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface SaveProfessionRequest {
    name?: string;
    sequenceOrder?: number;
    isLicensed?: boolean;
}

export interface QuizQuestion {
    id?: number;
    lessonId?: number;
    questionText?: string;
    questionType?: QuestionType;
    options?: QuizOption[];
    sequenceOrder?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum QuestionType {
    TrueFalse = 1,
    SingleChoice = 2,
    MultipleChoice = 3,
}

export interface QuizOption {
    text?: string;
    isCorrect?: boolean;
}

export interface SaveQuizQuestionsRequest {
    questions?: QuizQuestionItem[];
}

export interface QuizQuestionItem {
    questionText?: string;
    questionType?: QuestionType;
    options?: QuizOptionItem[];
}

export interface QuizOptionItem {
    text?: string;
    isCorrect?: boolean;
}

export interface QuizAttempt {
    id?: number;
    enrollmentId?: number;
    lessonId?: number;
    score?: number;
    passed?: boolean;
    totalQuestions?: number;
    correctAnswers?: number;
    answers?: QuizAnswerRecord[];
    startedAt?: Date;
    completedAt?: Date;
    createdAt?: Date;
}

export interface QuizAnswerRecord {
    questionId?: number;
    selectedOptionIndexes?: number[];
}

export interface SubmitQuizAttemptRequest {
    enrollmentId?: number;
    lessonId?: number;
    startedAt?: Date;
    answers?: QuizAnswerItem[];
}

export interface QuizAnswerItem {
    questionId?: number;
    selectedOptionIndexes?: number[];
}

export interface UserReferenceField {
    id?: number;
    workspaceId?: number;
    key?: string;
    label?: string;
    sequenceOrder?: number;
}

export interface SaveReferenceFieldRequest {
    key?: string;
    label?: string;
    sequenceOrder?: number;
    workspaceId?: number | undefined;
}

export interface UserReferenceFieldValue {
    id?: number;
    loginId?: number;
    fieldId?: number;
    value?: string | undefined;
}

export interface SetReferenceFieldValueRequest {
    fieldId?: number;
    value?: string | undefined;
}

export interface SendReminderRequest {
    userId?: number;
    assignmentDefinitionId?: number;
}

export interface ComplianceSummary {
    total?: number;
    upcoming?: number;
    active?: number;
    overdue?: number;
    completed?: number;
}

export interface ComplianceHeatmapCell {
    rowKey?: string;
    colKey?: string;
    rowId?: number | undefined;
    colId?: number | undefined;
    upcoming?: number;
    active?: number;
    overdue?: number;
    completed?: number;
}

export interface ComplianceSnapshot {
    snapshotAt?: Date;
    total?: number;
    completed?: number;
}

export interface SasUploadResult {
    filename?: string;
    sasUrl?: string;
}

export interface VideoUploadResponse {
    uploadUrl?: string;
    lessonId?: number;
}

export interface CreateVideoUploadRequest {
    lessonId?: number;
}

export interface VideoPlaybackResponse {
    playbackId?: string;
    token?: string;
    duration?: number | undefined;
    status?: string;
}

export interface PagedResultOfTag {
    items?: Tag[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface SaveTagRequest {
    name?: string;
    tagType?: TagType;
    workspaceId?: number | undefined;
}

export interface AddUsersToTagRequest {
    userIds?: number[];
}

export interface UserTag {
    userId?: number;
    tagId?: number;
    createdAt?: Date;
    tag?: Tag | undefined;
    user?: Login | undefined;
}

export interface Login {
    id?: number;
    accountId?: number | undefined;
    workspaceId?: number | undefined;
    workspaceName?: string | undefined;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    passwordHash?: string | undefined;
    role?: UserRole;
    otp?: string | undefined;
    isActive?: boolean;
    profileImageUrl?: string | undefined;
    jobTitle?: string | undefined;
    professionId?: number | undefined;
    invitationToken?: string | undefined;
    invitationExpiresAt?: Date | undefined;
    invitedByUserId?: number | undefined;
    lastLoginAt?: Date | undefined;
    isPendingInvitation?: boolean;
    isInvitationExpired?: boolean;
    tags?: Tag[];
    groups?: Group[];
    createdAt?: Date;
    updatedAt?: Date | undefined;
}

export interface PagedResultOfLogin {
    items?: Login[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface CreateUserRequest {
    email?: string;
    firstName?: string;
    lastName?: string;
    password?: string;
    role?: number;
    accountId?: number | undefined;
    workspaceId?: number | undefined;
}

export interface UpdateUserRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: number | undefined;
    workspaceId?: number | undefined;
    profileImageUrl?: string | undefined;
    jobTitle?: string | undefined;
}

export interface InvitationResponse {
    id?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: number;
    workspaceId?: number | undefined;
    invitationExpiresAt?: Date | undefined;
    invitedByUserId?: number | undefined;
    createdAt?: Date;
    isExpired?: boolean;
}

export interface InviteUserRequest {
    email: string;
    firstName: string;
    lastName: string;
    role: number;
    workspaceId?: number | undefined;
    tagIds?: number[] | undefined;
}

export interface BulkInviteUsersRequest {
    users: InviteUserRequest[];
}

export interface ResetUserPasswordRequest {
    newPassword: string;
    confirmPassword: string;
}

export interface PagedResultOfWorkspace {
    items?: Workspace[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface Workspace {
    id?: number;
    name?: string;
    accountId?: number;
    createdAt?: Date;
    updatedAt?: Date;
    primaryColor?: string | undefined;
    logoUrl?: string | undefined;
    favicon?: string | undefined;
    bannerHtml?: string | undefined;
    bannerImageUrl?: string | undefined;
    dashboardWidgetHtml?: string | undefined;
    seatLimit?: number | undefined;
    tier?: WorkspaceTier;
    allowLearnerSelfEdit?: boolean;
    emailNotificationsEnabled?: boolean;
    deactivatedAt?: Date | undefined;
    contentTagIds?: number[];
    provisionedCourseIds?: number[];
    groupCount?: number;
    activeLearnerCount?: number;
    activeAdminCount?: number;
}

export enum WorkspaceTier {
    Standard = 1,
    Enterprise = 2,
    Demo = 3,
}

export interface AddWorkspaceRequest {
    name?: string;
    primaryColor?: string | undefined;
    logoUrl?: string | undefined;
    favicon?: string | undefined;
    bannerHtml?: string | undefined;
    bannerImageUrl?: string | undefined;
    dashboardWidgetHtml?: string | undefined;
}

export interface UpdateWorkspaceRequest {
    name?: string;
    primaryColor?: string | undefined;
    logoUrl?: string | undefined;
    favicon?: string | undefined;
    bannerHtml?: string | undefined;
    bannerImageUrl?: string | undefined;
    dashboardWidgetHtml?: string | undefined;
}

export interface UpdateWorkspaceAccessRequest {
    seatLimit?: number | undefined;
    tier?: WorkspaceTier;
    allowLearnerSelfEdit?: boolean;
    emailNotificationsEnabled?: boolean;
    contentTagIds?: number[] | undefined;
    provisionedCourseIds?: number[] | undefined;
}

export interface SetWorkspaceStatusRequest {
    deactivated?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}